// Array güvenlik utility fonksiyonları

/**
 * Bir değerin array olup olmadığını kontrol eder ve güvenli array döndürür
 */
export const ensureArray = <T>(value: T[] | null | undefined): T[] => {
  return Array.isArray(value) ? value : [];
};

/**
 * Array length'ini güvenli şekilde alır
 */
export const safeLength = (value: any[] | null | undefined): number => {
  return Array.isArray(value) ? value.length : 0;
};

/**
 * Array filter'ını güvenli şekilde yapar
 */
export const safeFilter = <T>(
  array: T[] | null | undefined,
  predicate: (value: T, index: number, array: T[]) => boolean
): T[] => {
  return Array.isArray(array) ? array.filter(predicate) : [];
};

/**
 * Array map'ini güvenli şekilde yapar
 */
export const safeMap = <T, U>(
  array: T[] | null | undefined,
  callback: (value: T, index: number, array: T[]) => U
): U[] => {
  return Array.isArray(array) ? array.map(callback) : [];
};

/**
 * Array reduce'unu güvenli şekilde yapar
 */
export const safeReduce = <T, U>(
  array: T[] | null | undefined,
  callback: (previousValue: U, currentValue: T, currentIndex: number, array: T[]) => U,
  initialValue: U
): U => {
  return Array.isArray(array) ? array.reduce(callback, initialValue) : initialValue;
};

/**
 * Bir objenin property'sinin array olmasını sağlar
 */
export const ensureObjectArrayProperty = <T extends Record<string, any>, K extends keyof T>(
  obj: T | null | undefined,
  key: K
): any[] => {
  if (!obj || typeof obj !== 'object') return [];
  return ensureArray(obj[key]);
};

/**
 * Dashboard data için güvenli fallback
 */
export const safeDashboardData = (data: any) => {
  if (!data || typeof data !== 'object') {
    return {
      users: [],
      companies: [],
      physicalServers: [],
      virtualServers: [],
      gsmLines: [],
      orders: [],
      technicalServices: [],
      capexList: [],
      storageUnits: [],
      networkSwitches: [],
      activities: []
    };
  }

  return {
    users: ensureArray(data.users),
    companies: ensureArray(data.companies),
    physicalServers: ensureArray(data.physicalServers),
    virtualServers: ensureArray(data.virtualServers),
    gsmLines: ensureArray(data.gsmLines),
    orders: ensureArray(data.orders),
    technicalServices: ensureArray(data.technicalServices),
    capexList: ensureArray(data.capexList),
    storageUnits: ensureArray(data.storageUnits),
    networkSwitches: ensureArray(data.networkSwitches),
    activities: ensureArray(data.activities)
  };
};